import ExtraCompoent from "../Form/ExtraComponent"
import { PageProps } from '../../components/types'
import { ExtraReturnStatus } from "../../models"
import { useState, useCallback, useMemo } from 'react'
import HeaderList from "../../components/HeaderList"

export default function PicklistExtra({ title, division, from, to, username, line, readOnly }: PageProps) {
  const [status, setStatus] = useState<ExtraReturnStatus>(ExtraReturnStatus.NEW)
  const [dateRange, setDateRange] = useState<[Date, Date]>([from || new Date(), to || new Date()]);
  const [keyword, setKeyword] = useState<string>('')
  const [div, setDiv] = useState<string>(division!)
  const [orderType, setOrderType] = useState<string>(line || '')

  const filterChanged = useCallback((
    key: string, value: string, dateRange?: [Date, Date], values?: string[]) => {
    switch(key) {
      case 'Order Type':
        return setOrderType(value)
      case 'Status':
        const sts = values![0] as ExtraReturnStatus
        return setStatus(sts)
      case 'Released Date Range':
        return setDateRange(dateRange!)
      case 'Search':
        return setKeyword(value)
      case 'Division':
        return setDiv(value)
      default:
        break
    }
  }, [ ])

  const coupleStatuses = useMemo(() => [
    ExtraReturnStatus.NEW, ExtraReturnStatus.APPROVED, ExtraReturnStatus.CANCELED
  ], [])

  return <div className="page-container">
    <HeaderList title={title} subTitle={`แผนก : ${division}`}
      orderType={orderType}
      statuses={[status]}
      dateRange={dateRange}
      keywordSearch={keyword}
      coupleStatuses={coupleStatuses}
      filterChanged={filterChanged}
      division={div}
    />
    <ExtraCompoent
      username={username!}
      status={status} dateRange={dateRange} keyword={keyword}
      division={div} orderType={orderType}
      readOnly={readOnly}
    />
  </div>
}